import { Dispatch } from 'redux';
import { setLicenseAgreement } from './License.services';
import { httpError, json, showWarnNotification } from 'common';

import { SetResultLoadingType, LICENSE_SET_LOADING } from './License.types';

function go2dashboard() {
  const str = window.location.href.replace('license', 'dashboard');
  window.location.href = str;
  //window.location = window.location.host;
}

export const setLicenseFlag =
  (username: string, bearerToken: string) => (dispatch: Dispatch) => {
    dispatch(setResultLoading(true));
    //alert("Save");
    setLicenseAgreement(username, bearerToken)
      .then(httpError(dispatch))
      .then(json)
      .then((response) => {
        if (response.errorMessage) throw Error(response.errorMessage);
        go2dashboard();
        /*showSuccessNotification(
        'End User License Agreement',
        'Accepted the End User License Agreement Successfully".',
      ); */
      })
      .catch((error) => {
        showWarnNotification(`License Agreement`, error.message);
      });
  };
const setResultLoading = (loading: boolean): SetResultLoadingType => ({
  type: LICENSE_SET_LOADING,
  loading,
});
